module.exports = __webpack_public_path__ + "static/media/partnership-mobile.0691aed2.png";